"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IngestionChannel = void 0;
/**
 * @description IngestionChannel: Includes 3P channel of order ingestion, eg: Shopify (B2B), Pipe17, SPS, OrderFull
 */
var IngestionChannel;
(function (IngestionChannel) {
    IngestionChannel["SPS"] = "SPS";
    IngestionChannel["SPS_TEST"] = "SPS_TEST";
    IngestionChannel["SHOPIFY_V3"] = "SHOPIFY_V3";
    IngestionChannel["SELLERCLOUD"] = "SELLERCLOUD";
})(IngestionChannel || (exports.IngestionChannel = IngestionChannel = {}));
//# sourceMappingURL=IngestionChannel.js.map